// @flow

// import { History } from 'history';
import { combineReducers } from 'redux-immutable';
// import { connectRouter } from 'connected-react-router/immutable';
import Home from 'client/containers/Home/redux';
import Search from 'client/containers/Search/redux';
import Login from 'client/containers/Login/redux';
import Profile from 'client/containers/Profile/redux';
import Play from 'client/containers/Play/redux';

const createRootReducer = () => combineReducers({
  // router: connectRouter(history),
  Home,
  Search,
  Login,
  Profile,
  Play,
});

export default createRootReducer;
